import React, { ComponentProps } from 'react';
import { Flex } from 'glints-aries/es';
import { Banner, Button, Icon, Typography } from 'glints-aries/es/@next';
import { Neutral, Orange } from 'glints-aries/es/@next/utilities/colors';
import { space4, space12 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const SuggestedBanner = styled(Banner)`
  min-height: unset;
  margin-top: ${space12};
  border: 0px;
`;

export default function MismatchedFieldWarning({
  warningMessage,
  showWarning = true,
  suggestionMessage,
  onClick,
}: {
  warningMessage: ComponentProps<typeof FormattedMessage>;
  showWarning?: boolean;
  suggestionMessage: ComponentProps<typeof FormattedMessage>;
  onClick: () => void;
}) {
  return (
    <>
      <If condition={showWarning}>
        <Flex flexDirection="row" gap={space4}>
          <Icon
            name="ri-error-warning-fill"
            fill={Orange.S86}
            width={24}
            height={24}
          />
          <Typography variant="subtitle2" color={Orange.S86}>
            <FormattedMessage {...warningMessage} />
          </Typography>
        </Flex>
      </If>
      <SuggestedBanner showIcon={false} dismissable={false}>
        <Flex flexDirection="row" gap="20px" justifyContent="space-between">
          <Typography variant="body1" color={Neutral.B18}>
            <FormattedMessage {...suggestionMessage} />
          </Typography>
          <Button onClick={onClick}>
            <Typography variant="button">
              <FormattedMessage id="interactive-apply" defaultMessage="Apply" />
            </Typography>
          </Button>
        </Flex>
      </SuggestedBanner>
    </>
  );
}
